module.exports = {
    showMap (args, state, output, { locator }) {
        let gismap = locator.resolve('gismap');
        gismap.showMap();
    }
};



// WEBPACK FOOTER //
// ./actions/contacts.js